import { render, staticRenderFns } from "./suspend-subscription-modal.vue?vue&type=template&id=3120f7cf&scoped=true&"
import script from "./suspend-subscription-modal.vue?vue&type=script&lang=ts&"
export * from "./suspend-subscription-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3120f7cf",
  null
  
)

export default component.exports